









































































































import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import { BModal, BFormGroup, BFormInput, BFormFile, BFormSelect, BButton, BSpinner } from "bootstrap-vue";
import AppHeading from "@/components/AppHeading.vue";
import { TeamMember, CreateTeamMember, Role, RoleNames, Position } from "@/models";
import Vuelidate from "vuelidate";
import { required, requiredIf, requiredUnless, email, minValue, maxValue } from "vuelidate/lib/validators";
import { Validations } from "vuelidate-property-decorators";

Vue.use(Vuelidate);

@Component({
  name: "MyTeamsPlayerForm",
  data() {
    return {
      form: {
        email: "",
        phone: "",
        firstname: "",
        lastname: "",
        mother_name: "",
        image_url: undefined,
        squad_number: "",
        position_id: undefined,
        role_id: undefined,
        birth_date: ""
      },
      roleOptions: [],
      positionOptions: [],
      canResendInvitation: false,
      isSendingInvitation: false,
      isLoading: false
    };
  },
  components: {
    AppHeading,
    BModal,
    BFormGroup,
    BFormInput,
    BFormFile,
    BFormSelect,
    BButton,
    BSpinner
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name]!;
      return $dirty ? !$error : null;
    }
  }
})
export default class MyTeamsPlayerForm extends Vue {
  form: CreateTeamMember | {} = {};
  roleOptions!: { text: string; value: number; disabled?: boolean }[];
  positionOptions!: { text: string; value: number; disabled?: boolean }[];
  isLoading!: boolean;
  isSendingInvitation!: boolean;
  canResendInvitation!: boolean;

  @Prop({ required: true, type: String }) type!: "edit" | "new";
  @Prop({ required: true, type: Function }) handleResendInvitation: (memberId: number) => Promise<any>;
  @Prop({ required: true, type: Function }) handleSubmit!: (createTeamMember: CreateTeamMember) => Promise<any>;
  @Prop({ required: true, type: Function }) onDelete!: (userId: number) => Promise<any>;
  @Prop({ required: true }) member!: TeamMember;
  @Prop({ required: true }) roles!: Role[];
  @Prop({ required: true }) positions!: Position[];

  get isEditMode() {
    return this.type === "edit";
  }

  @Watch("member", { immediate: true })
  onMemberChange(newTeamMember: TeamMember) {
    this.form = {
      ...this.form,
      squad_number: newTeamMember.squad_number,
      role_id: newTeamMember.role && newTeamMember.role.id,
      position_id: newTeamMember.position && newTeamMember.position.id,
      image_url: undefined
    };
    this.canResendInvitation = !this.$moment(this.member.last_sent_invitation).isSame(new Date(), "day");
  }

  @Watch("roles", { immediate: true })
  @Watch("member", { immediate: true })
  setRoleOptions() {
    this.roleOptions = this.roles.map(role => ({
      value: role.id,
      text: role.name,
      disabled: role.name === RoleNames.Member && this.member.role && this.member.role.name === RoleNames.Captain
    }));
  }

  @Watch("positions", { immediate: true })
  onPositionsChange(newPositions: Position[]) {
    this.positionOptions = newPositions.map(position => ({ value: position.id, text: position.name }));
  }

  async handleFormSubmit() {
    this.isLoading = true;
    await this.handleSubmit({
      ...(this.form as CreateTeamMember)
    });
    this.isLoading = false;
  }

  async handleDelete(userId: number) {
    this.isLoading = true;
    await this.onDelete(userId);
    this.isLoading = false;
  }

  async onResendInvitation() {
    this.isSendingInvitation = true;
    await this.handleResendInvitation(this.member.id);
    this.isSendingInvitation = false;
  }

  @Validations()
  validations = {
    form: {
      firstname: {
        required: requiredUnless(() => this.isEditMode)
      },
      lastname: {
        required: requiredUnless(() => this.isEditMode)
      },
      email: {
        required: requiredUnless(() => this.isEditMode),
        email
      },
      phone: {
        required: requiredUnless(() => this.isEditMode)
      },
      birth_date: {
        required: requiredUnless(() => this.isEditMode),
        validation: (value: string, vm: Vue) => {
          if (this.isEditMode) {
            return true;
          }

          const maxBirthDate = new Date();
          maxBirthDate.setFullYear(maxBirthDate.getFullYear() - 16);
          return new Date(value) <= maxBirthDate;
        }
      },
      mother_name: {
        required: requiredUnless(() => this.isEditMode)
      },
      role_id: {
        required
      },
      position_id: {
        required
      },
      squad_number: {
        required,
        minValue: minValue(1)
      },
      image_url: {}
    }
  };
}
